module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero14.png?c0af7edf";